import {
  LOGIN_ERROR,
  REMOVE_FORGOT_DATA,
  ACK_FORGOT_OTP_SEND,
  SAVE_FORGOT_DATA,
  TOKEN_GENRATE,
  USER_CHANGEPASSWORD,
  CLEAR_MUST_CHANGE_PASSWORD,
  USER_FORGOT,
  USER_LOGIN,
  USER_LOGOUT,
  USER_OTPVERIFY,
  USER_UPDATEPASSWORD,
} from "../types";

const initialState = {
  response: null,
  authToken: false,
  loading: true,
  create: false,
  detail: false,
};
const initialStateForgot = {
  response: null,
  otpSend: false,
  loading: true,
  reset: false,
};
const initialStateChangePassword = {
  response: null,
  loading: true,
  change: false,
};

export function authStore(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        response: action.payload,
        authToken: true,
      };

    case USER_LOGOUT:
      return {
        ...state,
        response: null,
        authToken: false,
      };

    case TOKEN_GENRATE:
      if (state.authToken) {
        return state;
      }
      return {
        ...state,
        response: action.payload,
      };
    case CLEAR_MUST_CHANGE_PASSWORD: {
      const current = state.response;
      if (!current) {
        return state;
      }
      const data = current.data;
      const nextData = Array.isArray(data)
        ? data.map((item, index) =>
            index === 0
              ? {
                  ...item,
                  must_change_password: false,
                  passwordChangedDate: new Date().toISOString(),
                }
              : item,
          )
        : {
            ...(data || {}),
            must_change_password: false,
            passwordChangedDate: new Date().toISOString(),
          };
      return {
        ...state,
        response: {
          ...current,
          data: nextData,
        },
      };
    }
    default:
      return state;
  }
}
export function forgotPassStore(state = initialStateForgot, action) {
  switch (action.type) {

    case USER_FORGOT:
      return {
        ...state,
        response: action.payload,
        reset: false,
        verifyotp: false,
        otpSend: true,
        data:action.data,
      };
    case ACK_FORGOT_OTP_SEND:
      return {
        ...state,
        otpSend: false,
      };
    case USER_OTPVERIFY:
      return {
        ...state,
        response: action.payload, 
        otpSend: false,
        reset: false,
        verifyotp: true,
      };
    case USER_UPDATEPASSWORD:
      return {
        ...state,
        response: action.payload, 
        reset: true,
      };
    case REMOVE_FORGOT_DATA:
      return {
        ...initialStateForgot,
      };
      case SAVE_FORGOT_DATA:
        return {
          ...state,
          response: action.payload,
          authToken: false,
        };
        case LOGIN_ERROR:
          return {
            ...state,
            detail: true,
            create: true,
            response: action.payload,
          };
    default:
      return state;
  }
}
export function changePassStore(state = initialStateChangePassword, action) {
  switch (action.type) {

    case USER_CHANGEPASSWORD:
      return {
        ...state,
        response: action.payload, 
        change: true,
      };
      case REMOVE_FORGOT_DATA:
      return {
        ...state,
        response: action.payload,
        authToken: false,
      };
    default:
      return state;
  }
}
